const Mutations = Object.freeze({
	SET_ENTITIES: 'dataImport/templates/SET_ENTITIES',
	SET_TEMPLATES: 'dataImport/templates/SET_TEMPLATES',
	SET_TEMPLATES_ADD: 'dataImport/templates/SET_TEMPLATES_ADD',
	SET_TEMPLATES_UPDATE: 'dataImport/templates/SET_TEMPLATES_UPDATE',
	SET_TEMPLATES_DELETE: 'dataImport/templates/SET_TEMPLATES_DELETE',

	SET_TEMPLATE_FIELDS: 'dataImport/templates/SET_TEMPLATE_FIELDS',
	SET_LOADING_FIELDS: 'dataImport/templates/SET_LOADING_FIELDS',
	SET_TEMPLATE_FIELDS_ADD: 'dataImport/templates/SET_TEMPLATE_FIELDS_ADD',
	SET_TEMPLATE_FIELDS_UPDATE:
		'dataImport/templates/SET_TEMPLATE_FIELDS_UPDATE',
	SET_TEMPLATE_FIELDS_DELETE:
		'dataImport/templates/SET_TEMPLATE_FIELDS_DELETE',

	SET_REFERENCE_LIST_TYPES: 'dataImport/templates/SET_REFERENCE_LIST_TYPES',
	SET_DATA_FIELDS: 'dataImport/templates/SET_DATA_FIELDS',
	SET_GRID_VIEWS: 'dataImport/templates/SET_GRID_VIEWS',
});

export const Actions = Object.freeze({
	CLEAR: 'dataImport/templates/CLEAR',
	CLEAR_TEMPLATE_MODAL: 'dataImport/templates/CLEAR_TEMPLATE_MODAL',

	LOAD_ENTITIES: 'dataImport/templates/LOAD_ENTITIES',

	LOAD_TEMPLATES: 'dataImport/templates/LOAD_TEMPLATES',
	ADD_TEMPLATE: 'dataImport/templates/ADD_TEMPLATE',
	UPDATE_TEMPLATE: 'dataImport/templates/UPDATE_TEMPLATE',
	DELETE_TEMPLATE: 'dataImport/templates/DELETE_TEMPLATE',

	LOAD_TEMPLATE_FIELDS: 'dataImport/templates/LOAD_TEMPLATE_FIELDS',
	CLEAR_TEMPLATE_FIELDS: 'dataImport/templates/CLEAR_TEMPLATE_FIELDS',
	UPLOAD_TEMPLATE_FIELDS: 'dataImport/templates/UPLOAD_TEMPLATE_FIELDS',

	ADD_TEMPLATE_FIELD: 'dataImport/templates/ADD_TEMPLATE_FIELD',
	UPDATE_TEMPLATE_FIELD: 'dataImport/templates/UPDATE_TEMPLATE_FIELD',
	DELETE_TEMPLATE_FIELD: 'dataImport/templates/DELETE_TEMPLATE_FIELD',

	LOAD_TEMPLATE_FIELD_MODAL: 'dataImport/templates/LOAD_TEMPLATE_FIELD_MODAL',
	CLEAR_TEMPLATE_FIELD_MODAL:
		'dataImport/templates/CLEAR_TEMPLATE_FIELD_MODAL',

	REORDER_COLUMNS: 'dataImport/templates/REORDER_COLUMNS',
});

export const Getters = Object.freeze({
	ENTITIES: 'dataImport/templates/ENTITIES',
	TEMPLATES: 'dataImport/templates/TEMPLATES',
	LOADING_FIELDS: 'dataImport/templates/LOADING_FIELDS',
	TEMPLATE_FIELDS: 'dataImport/templates/TEMPLATE_FIELDS',

	GET_REFERENCE_LIST_TYPES: 'dataImport/templates/GET_REFERENCE_LIST_TYPES',
	GET_DATA_FIELDS: 'dataImport/templates/GET_DATA_FIELDS',
	GET_GRID_VIEWS: 'dataImport/templates/GET_GRID_VIEWS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/importDataService';

export default {
	state: {
		entities: [],
		templates: [],
		templateFields: [],
		loadingFields: false,

		dataFields: [],
		referenceListTypes: [],
		gridViews: [],
	},
	mutations: {
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_TEMPLATES](state, items) {
			state.templates = items;
		},
		[Mutations.SET_TEMPLATES_ADD](state, item) {
			state.templates.push(item);
		},
		[Mutations.SET_TEMPLATES_UPDATE](state, item) {
			let index = state.templates.findIndex((x) => x.Id === item.Id);
			state.templates.splice(index, 1, item);
		},
		[Mutations.SET_TEMPLATES_DELETE](state, id) {
			let deleteIndex = state.templates.findIndex((x) => x.Id === id);
			state.templates.splice(deleteIndex, 1);
		},

		[Mutations.SET_TEMPLATE_FIELDS](state, items) {
			state.templateFields = items;
		},
		[Mutations.SET_LOADING_FIELDS](state, value) {
			state.loadingFields = value;
		},
		[Mutations.SET_TEMPLATE_FIELDS_ADD](state, item) {
			state.templateFields.push(item);
		},
		[Mutations.SET_TEMPLATE_FIELDS_UPDATE](state, item) {
			let index = state.templateFields.findIndex((x) => x.Id === item.Id);
			state.templateFields.splice(index, 1, item);
		},
		[Mutations.SET_TEMPLATE_FIELDS_DELETE](state, id) {
			let deleteIndex = state.templateFields.findIndex(
				(x) => x.Id === id
			);
			state.templateFields.splice(deleteIndex, 1);
		},

		[Mutations.SET_DATA_FIELDS](state, items) {
			state.dataFields = items;
		},
		[Mutations.SET_REFERENCE_LIST_TYPES](state, items) {
			state.referenceListTypes = items;
		},
		[Mutations.SET_GRID_VIEWS](state, items) {
			state.gridViews = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_TEMPLATES, []);
				commit(Mutations.SET_TEMPLATE_FIELDS, []);
				commit(Mutations.SET_LOADING_FIELDS, false);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.CLEAR_TEMPLATE_MODAL]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_ENTITIES, []);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_TEMPLATES]({ commit, dispatch }) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.getTemplates()
					.then((resp) => {
						commit(Mutations.SET_TEMPLATES, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.ADD_TEMPLATE]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertTemplate(item)
					.then((resp) => {
						commit(Mutations.SET_TEMPLATES_ADD, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_TEMPLATE]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateTemplate(item)
					.then(() => {
						commit(Mutations.SET_TEMPLATES_UPDATE, item);
						resolve(item);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.DELETE_TEMPLATE]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteTemplate(id)
					.then(() => {
						commit(Mutations.SET_TEMPLATES_DELETE, id);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOAD_ENTITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getEntities()
					.then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOAD_TEMPLATE_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getTemplateFields(id)
					.then((resp) => {
						commit(Mutations.SET_TEMPLATE_FIELDS, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.CLEAR_TEMPLATE_FIELDS]({ commit }) {
			commit(Mutations.SET_TEMPLATE_FIELDS, []);
		},
		[Actions.UPLOAD_TEMPLATE_FIELDS]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('file', item.file);
				formData.append('item', JSON.stringify(item.importFile));
				dataService
					.uploadImportTemplateFields(formData)
					.then((response) => {
						commit(Mutations.SET_TEMPLATE_FIELDS, response.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.ADD_TEMPLATE_FIELD]({ commit, dispatch }, field) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertTemplateField(field)
					.then((resp) => {
						commit(Mutations.SET_TEMPLATE_FIELDS_ADD, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.UPDATE_TEMPLATE_FIELD]({ commit, dispatch }, field) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateTemplateField(field)
					.then((resp) => {
						commit(Mutations.SET_TEMPLATE_FIELDS_UPDATE, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_TEMPLATE_FIELD]({ commit, dispatch }, field) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteTemplateField(field)
					.then(() => {
						commit(Mutations.SET_TEMPLATE_FIELDS_DELETE, field.Id);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOAD_TEMPLATE_FIELD_MODAL]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dataService.getEntities().then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
					}),
					dataService.getDataFields().then((resp) => {
						commit(Mutations.SET_DATA_FIELDS, resp.data);
					}),
					dataService.getDefaultGridViews().then((resp) => {
						commit(Mutations.SET_GRID_VIEWS, resp.data);
					}),
					dataService.getReferenceListTypes().then((resp) => {
						commit(Mutations.SET_REFERENCE_LIST_TYPES, resp.data);
					}),
				])
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.CLEAR_TEMPLATE_FIELD_MODAL]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_DATA_FIELDS, []);
				commit(Mutations.SET_GRID_VIEWS, []);
				commit(Mutations.SET_REFERENCE_LIST_TYPES, []);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.REORDER_COLUMNS]({ dispatch }, data) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateColumns(data)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.TEMPLATES]: (state) => {
			if (!state.templates) return [];
			if (state.templates.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.templates.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
		[Getters.ENTITIES]: (state) => {
			if (!state.entities) return [];
			if (state.entities.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.entities.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
		[Getters.LOADING_FIELDS]: (state) => {
			return state.loadingFields;
		},
		[Getters.TEMPLATE_FIELDS]: (state) => {
			if (!state.templateFields) return [];
			if (state.templateFields.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.templateFields.sort((a, b) => a.Order - b.Order)
				)
			);
		},
		[Getters.GET_DATA_FIELDS]: (state) => {
			if (state.dataFields && state.dataFields.length > 0) {
				return JSON.parse(JSON.stringify(state.dataFields));
			}
			return [];
		},
		[Getters.GET_REFERENCE_LIST_TYPES]: (state) => {
			if (
				state.referenceListTypes &&
				state.referenceListTypes.length > 0
			) {
				return JSON.parse(JSON.stringify(state.referenceListTypes));
			}
			return [];
		},
		[Getters.GET_GRID_VIEWS]: (state) => {
			if (state.gridViews && state.gridViews.length > 0) {
				return JSON.parse(JSON.stringify(state.gridViews));
			}
			return [];
		},
	},
};

/*
const Mutations = Object.freeze({
    SET_LOADING: "dataImport/templates/SET_LOADING",
    SET_ENTITIES: "dataImport/templates/SET_ENTITIES",
    SET_TEMPLATES: "dataImport/templates/SET_TEMPLATES",
    SET_EDIT_FIELD: "dataImport/templates/SET_EDIT_FIELD",
    SET_TEMPLATE_INSERT: "dataImport/templates/SET_TEMPLATE_INSERT",
    SET_TEMPLATE_UPDATE: "dataImport/templates/SET_TEMPLATE_UPDATE",
    SET_EDIT_TEMPLATE: "dataImport/templates/SET_EDIT_TEMPLATE",
    SET_TEMPLATE_FIELDS: "dataImport/templates/SET_TEMPLATE_FIELDS",
    SET_SELECTED_TEMPLATE: "dataImport/templates/SET_SELECTED_TEMPLATE",
    SET_SELECTED_ENTITY: "dataImport/templates/SET_SELECTED_ENTITY",
    DELETE_TEMPLATE_FIELD: "dataImport/templates/DELETE_TEMPLATE_FIELD",
    DELETE_TEMPLATE: "dataImport/templates/DELETE_TEMPLATE",
    SET_ADD_FIELD: "dataImport/templates/SET_ADD_FIELD",
    SET_UPDATE_FIELD: "dataImport/templates/SET_UPDATE_FIELD",
});
export const Actions = Object.freeze({
    LOAD: "dataImport/templates/LOAD",
    LOAD_TEMPLATES: "dataImport/templates/LOAD_TEMPLATES",
    LOAD_ALL: "dataImport/templates/LOAD_ALL",
    LOAD_DATA_FIELDS: "dataImport/templates/LOAD_DATA_FIELDS",
    LOAD_EDIT_FIELD: "dataImport/templates/LOAD_EDIT_FIELD",
    LOAD_EDIT_TEMPLATE: "dataImport/templates/LOAD_EDIT_TEMPLATE",
    LOAD_SELECTED_TEMPLATE: "dataImport/templates/LOAD_SELECTED_TEMPLATE",
    LOAD_ENTITIES: "dataImport/templates/LOAD_ENTITIES",
    LOAD_REFERENCE_LIST_TYPES: "dataImport/templates/LOAD_REFERENCE_LIST_TYPES",
    LOAD_TEMPLATE_FIELDS: "dataImport/templates/LOAD_TEMPLATE_FIELDS",
    INSERT_TEMPLATE: "dataImport/templates/INSERT_TEMPLATE",
    UPDATE_TEMPLATE: "dataImport/templates/UPDATE_TEMPLATE",
    DELETE_TEMPLATE: "dataImport/templates/DELETE_TEMPLATE",
    
    
    CLEAR: "dataImport/templates/CLEAR",
    CLEAR_EDIT_TEMPLATE: "dataImport/templates/CLEAR_EDIT_TEMPLATE",
    CLEAR_TEMPLATE_FIELDS: "dataImport/templates/CLEAR_TEMPLATE_FIELDS",
    
});
export const Getters = Object.freeze({
    GET_TEMPLATES: "dataImport/templates/GET_TEMPLATES",
    GET_EDIT_TEMPLATE: "dataImport/templates/GET_EDIT_TEMPLATE",
    GET_TEMPLATE_FIELDS: "dataImport/templates/GET_TEMPLATE_FIELDS",
    GET_EDIT_FIELD: "dataImport/templates/GET_EDIT_FIELD",
    GET_SELECTED_TEMPLATE: "dataImport/templates/GET_SELECTED_TEMPLATE",
    GET_SELECTED_ENTITY: "dataImport/templates/GET_SELECTED_ENTITY",
    GRID_LOADING: "dataImport/templates/GRID_LOADING"
});


export default {
    state: {
        entities: [],
        templates: [],
        selectedEditTemplate: null,
        selectedTemplate: null,
        referenceListTypes: [],
        dataFields: [],
        templateFields: [],
        selectedEditField: null,
        selectedEntity: null,
        loading: false
    },
    mutations: {
        [Mutations.SET_LOADING](state, value) {state.loading = value;},
        [Mutations.SET_TEMPLATES](state, value) {state.templates = value;},
        [Mutations.SET_TEMPLATE_FIELDS](state, value) {state.templateFields = value;},
       
        [Mutations.SET_EDIT_FIELD](state, item) {state.selectedEditField = item;},
        [Mutations.SET_TEMPLATE_INSERT](state, item) {state.templates.push(item);},
        

        [Mutations.SET_SELECTED_TEMPLATE](state, item) {state.selectedTemplate = item;},
        [Mutations.SET_EDIT_TEMPLATE](state, item) {state.selectedEditTemplate = item;},
        [Mutations.SET_SELECTED_ENTITY](state, item) {state.selectedEntity = item;},
        [Mutations.SET_ENTITIES](state, items) {state.entities = items;},
        [Mutations.SET_ADD_FIELD](state, item) {state.templateFields.push(item);},
        [Mutations.SET_UPDATE_FIELD](state,{oldItem,newItem})
        {
            let index= state.templateFields.indexOf(oldItem);
            if(index>=0)
            {
                state.templateFields.splice(index,1,newItem);
            }
        },

        [Mutations.DELETE_TEMPLATE_FIELD](state, id) {let deleteIndex = state.templateFields.findIndex(x => x.Id === id);state.templateFields.splice(deleteIndex, 1);},
        

    },
    actions: {
        [Actions.CLEAR]({ commit }) {
            return new Promise((resolve) => {
                commit(Mutations.SET_ENTITIES, []);
                commit(Mutations.SET_TEMPLATES, []);
                commit(Mutations.SET_TEMPLATE_FIELDS, [])
                commit(Mutations.SET_REFERENCE_LIST_TYPES, [])
                commit(Mutations.SET_DATA_FIELDS, [])
                commit(Mutations.SET_SELECTED_ENTITY, null)
                commit(Mutations.SET_SELECTED_TEMPLATE, null)
                commit(Mutations.SET_EDIT_FIELD, null)
                commit(Mutations.SET_LOADING, false);
                resolve();
            });
        },
        [Actions.CLEAR_TEMPLATE_FIELDS]({ commit }) {
            return new Promise((resolve) => {
                commit(Mutations.SET_TEMPLATE_FIELDS, [])
                resolve();
            });
        },
        
        [Actions.CLEAR_EDIT_TEMPLATE]({ commit }) {
            return new Promise((resolve) => {
                commit(Mutations.SET_EDIT_TEMPLATE, null)
                resolve();
            });
        },
        [Actions.LOAD]({ dispatch }) {
            return Promise.all([
                dispatch(GeneralActions.LOADING, true),
                dispatch(Actions.LOAD_ENTITIES),
                dispatch(Actions.LOAD_TEMPLATES)
            ]).then(() => { dispatch(GeneralActions.LOADING, false) })
        },
        [Actions.LOAD_ALL]({ commit, dispatch }) {
            return new Promise((resolve) => {

                Promise.all([
                    dataService.getDataFields().then(resp => {
                        commit(Mutations.SET_DATA_FIELDS, resp.data);
                    }),
                    dataService.getReferenceListTypes().then(resp => {
                        commit(Mutations.SET_REFERENCE_LIST_TYPES, resp.data);
                    })
                ]).then(() => {
                    resolve();
                }).catch(error => {
                    dispatch(GeneralActions.ERROR, error);
                    resolve();
                });
            });
        },
        
        [Actions.LOAD_SELECTED_TEMPLATE]({ commit, dispatch }, id) {
            return new Promise((resolve) => {
                dataService.getGridViewById(id).then(resp => {
                    commit(Mutations.SET_SELECTED_TEMPLATE, resp.data);
                    commit(Mutations.SET_SELECTED_ENTITY, resp.data.EntityId)
                    resolve();
                }).catch(error => {
                    dispatch(GeneralActions.ERROR, error);
                    resolve();
                })
            });
        },
        [Actions.LOAD_EDIT_FIELD]({ commit }, field) {
            commit(Mutations.SET_EDIT_FIELD, field);
        },
        [Actions.LOAD_EDIT_TEMPLATE]({ commit }, item) {
            commit(Mutations.SET_EDIT_TEMPLATE, item);
        },

        
       
        [Actions.LOAD_REFERENCE_LIST_TYPES]({ commit }) {
            return Promise.all([
                dataService.getReferenceListTypes().then(resp => {
                    commit(Mutations.SET_REFERENCE_LIST_TYPES, resp.data);
                })
            ]);
        },
        [Actions.LOAD_DATA_FIELDS]({ commit }) {
            return Promise.all([
                dataService.getDataFields().then(resp => {
                    commit(Mutations.SET_DATA_FIELDS, resp.data);
                }),
            ]);
        },
        
      
       

    },
    getters: {
        [Getters.GRID_LOADING]: (state) => {
            return state.loading === true;
        },
        [Getters.GET_ENTITIES]: state => {
            return JSON.parse(JSON.stringify(state.entities));
        },
        [Getters.GET_SELECTED_TEMPLATE]: state => {
            return JSON.parse(JSON.stringify(state.selectedTemplate));
        },
        [Getters.GET_SELECTED_ENTITY]: state => {
            return JSON.parse(JSON.stringify(state.selectedEntity));
        },
        [Getters.GET_TEMPLATES]: state => {
            return JSON.parse(JSON.stringify(state.templates));
        },
        
        
        [Getters.GET_EDIT_FIELD]: (state) => {
            return state.selectedEditField;
        },
        [Getters.GET_EDIT_TEMPLATE]: (state) => {
            return state.selectedEditTemplate;
        }

    }
}*/
